import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = () => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4178 11.4267H12.5818V8.32985H13.3569C13.6777 8.32985 13.9384 8.07285 13.9384 7.75581V6.57404C13.9384 6.25701 13.6777 6 13.3569 6H10.6431C10.3223 6 10.0616 6.25701 10.0616 6.57404V7.75581C10.0616 8.07285 10.3223 8.32985 10.6431 8.32985H11.4182V11.4267H4.58216C4.26064 11.4267 4 11.6836 4 12.0007C4 12.3177 4.26064 12.5747 4.58216 12.5747H7.01476V15.6701H6.2397C5.91886 15.6701 5.65822 15.9272 5.65822 16.2442V17.426C5.65822 17.743 5.91886 18 6.2397 18H8.95344C9.27427 18 9.53491 17.743 9.53491 17.426V16.2442C9.53491 15.9272 9.27427 15.6701 8.95344 15.6701H8.17837V12.5747H15.8216V15.6701H15.0466C14.7257 15.6701 14.4651 15.9272 14.4651 16.2442V17.426C14.4651 17.743 14.7257 18 15.0466 18H17.7603C18.0812 18 18.3418 17.743 18.3418 17.426V16.2442C18.3418 15.9272 18.0812 15.6701 17.7603 15.6701H16.9852V12.5747H19.4178C19.7394 12.5747 20 12.3177 20 12.0007C20 11.6836 19.7394 11.4267 19.4178 11.4267Z"
        fill="#A3A3A3"
      />
    </Svg>
  );
};

export default Icon;
